import { OrganizationalUnit } from 'src/app/modules/shared/models';

/**
 * Details for organizational unit change events broadcasted to microfrontends.
 */
export interface HostOuChangeDetail {
  ou: OrganizationalUnit;
  timestamp: number;
}

/**
 * Event broadcasted by the host every time the current organizational unit changes,
 * so microfrontends can react without owning the OU selection logic.
 */
export class HostOuChangeEvent extends CustomEvent<HostOuChangeDetail> {
  static readonly eventType = 'host-ou-change';

  constructor(detail: HostOuChangeDetail) {
    super(HostOuChangeEvent.eventType, { detail });
  }
}

/**
 * Details for organizational unit change requests from microfrontends to the host.
 */
export interface MicrofrontendOuChangeRequestDetail {
  ou: OrganizationalUnit;
  microfrontend: string;
  timestamp: number;
}

/**
 * Event dispatched by a microfrontend when it needs the current OU to change
 * The host applies it and answers with HostOuChangeEvent.
 */
export class MicrofrontendOuChangeRequestEvent extends CustomEvent<MicrofrontendOuChangeRequestDetail> {
  static readonly eventType = 'microfrontend-ou-change-request';

  constructor(detail: MicrofrontendOuChangeRequestDetail) {
    super(MicrofrontendOuChangeRequestEvent.eventType, { detail });
  }
}
